import React, { useState } from "react";
import "./album.css";
import { CardData } from "./cardData";
import Modal from "./modal";
import 'animate.css'

const AlbumCard = ({ number, win }) => {
  const [size, setSize] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (item) => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const getSize = (url) => {
    const img = new Image();
    img.onload = () => {
      setSize(img.width / img.height);
    };
    img.src = url;
  };

  const Imagen = () => {
    getSize(`../../../images/${number}.jpg`);
    if (size > 1) {
      if (win) {
        return (
          <div className={`bg-card${number} horizontal animate__animated animate__flipInX`}>
            <img
              src={`../../../images/${number}.jpg`}
              alt="imagen"
              onClick={openModal}
            />
          </div>
        );
      } else {
        return <div className={`bg-card${number} horizontal`}></div>;
      }
    } else {
      if (win) {
        return (
          <div className={`bg-card${number} vertical animate__animated animate__flipInY`}>
            <img
              src={`../../../images/${number}.jpg`}
              alt="imagen"
              onClick={openModal}
            />
          </div>
        );
      } else {
        return <div className={`bg-card${number} vertical`}></div>;
      }
    }
  };

  const info = CardData?.find((figurita) => figurita.id === number);

  return (
    <div className={`card${number} figurita`}>
      {Imagen(number)}
      <Modal isOpen={isModalOpen}  onClose={closeModal} number={number} title={info.title} description={info.description} />
    </div>
  );
};

export default AlbumCard;
